import { render, staticRenderFns } from "./SQLEditor.vue?vue&type=template&id=32efeef8&"
import script from "./SQLEditor.vue?vue&type=script&lang=js&"
export * from "./SQLEditor.vue?vue&type=script&lang=js&"
import style0 from "./SQLEditor.vue?vue&type=style&index=0&id=32efeef8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports